import { useEffect, useState } from "react";
import { Divider, Group, TextInput, Checkbox, Button, } from "@mantine/core";
import { Card, Flex, message, Spin } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";










const Companyprofiles = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [submitloading, setSubmitloading] = useState(false);
    const [companydetails, setCompanydetails] = useState({
        Company_name: '',
        Company_CIN_number: '',
        Company_PAN_number: '',
        Company_GST_number: '',
        Company_MSME_number: '',
        Company_address: '',
        Company_Mobile_number: '',
        Company_email: '',
    })
    const [directors, setDirectors] = useState([
        {
            Director_name: "",
            Director_mobile_number: "",
            Director_email: "",
            Director_DIN_number: "",
            Date_of_appointment: "",
            Share_perecentage: "",
            Is_Authroized_signatory: false,
        },
    ]);
    const [services, setServices] = useState({
        Payout: false,
        BBPS: false,
        Mobile_Recharge: false,
        Payin_UPI: false,
        Aeps: false,
        DMT: false,
        Payment_Gateway_PG: false,
        Bank_Verification: false,
    })
    const handelChangeCompanyDetails = (field, value) => {
        setCompanydetails(prev => ({
            ...prev,
            [field]: value
        }))
    }
    const handleChange = (index, field, value) => {

        const updated = [...directors];
        updated[index][field] = value;
        setDirectors(updated);
    };
    const handleAuthorizedChange = (index) => {
        const updated = directors.map((dir, i) => ({
            ...dir,
            Is_Authroized_signatory: i === index, // only one true
        }));
        setDirectors(updated);
    };
    const handleServiceChange = (service) => {
        setServices(prev => ({
            ...prev,
            [service]: !prev[service]
        }))
    }

    const addDirector = () => {
        setDirectors([
            ...directors,
            {
                Director_name: "",
                Director_mobile_number: "",
                Director_email: "",
                Director_DIN_number: "",
                Date_of_appointment: "",
                Share_perecentage: "",
                Is_Authroized_signatory: false,
            },
        ]);
    };
    const removeDirector = (index) => {
        const updated = directors.filter((_, i) => i !== index);

        // Edge case: ensure at least 1 director always exists
        if (updated.length === 0) {
            updated.push({
                Director_name: "",
                Director_mobile_number: "",
                Director_email: "",
                Director_DIN_number: "",
                Date_of_appointment: "",
                Share_perecentage: "",
                Is_Authroized_signatory: false,
            });
        }

        setDirectors(updated);
    };

    const getUserData = async () => { // for get the updated user data after company profile submission
        await fetch('https://api.boompay.in/get-user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        // const data = await response.json();
        // if (response.status === 200) {
        //     // console.log(data.user);
        //     setUserprofile(data.user);
        //     setActive(data.user.Completed_step);
        //     setLoading(false);
        // } else if (response.status === 401) {
        //     setLoading(false);
        //     console.log('Unauthorized access. Please log in again.');
        //     message.error('Unauthorized access. Please log in again.');
        // } else if (response.status === 404) {
        //     setLoading(false);
        //     console.log('User not found.');
        //     message.error('User not found.');
        // } else {
        //     setLoading(false);
        //     console.log('An error occurred while fetching user data.');
        //     message.error('An error occurred while fetching user data.');
        // }
    }

    const handleSubmit = async () => {
        const { Company_name, Company_CIN_number, Company_PAN_number, Company_GST_number, Company_MSME_number, Company_address, Company_Mobile_number, Company_email } = companydetails;
        if (!Company_name || !Company_CIN_number || !Company_PAN_number || !Company_GST_number || !Company_address || !Company_Mobile_number || !Company_email) {
            message.error('Please fill all required company details.');
            console.log('Please fill all required company details.');
            return;
        }
        if (directors.some(director => !director.Director_name || !director.Director_mobile_number || !director.Director_email || !director.Director_DIN_number || !director.Date_of_appointment || !director.Share_perecentage)) {
            message.error('Please fill all required director details.');
            console.log('Please fill all required director details.');
            return;
        }
        if (Object.keys(services).every(service => !services[service])) {
            message.error('Please select at least one service.');
            console.log('Please select at least one service.');
            return;
        }
        if (directors.filter(director => director.Is_Authroized_signatory).length === 0) {
            message.error('Please select at least one authorized signatory.');
            console.log('Please select at least one authorized signatory.');
            return;
        }
        if (directors.filter(director => director.Is_Authroized_signatory).length > 1) {
            message.error('Only one director can be the authorized signatory. Please correct the selection.');
            console.log('Only one director can be the authorized signatory. Please correct the selection.');
            return;
        }
        if (directors.reduce((total, director) => total + Number(director.Share_perecentage), 0) !== 100) {
            message.error('Total share percentage must equal 100%. Please adjust the share percentages.');
            console.log('Total share percentage must equal 100%. Please adjust the share percentages.');
            return;
        }
        if (!/^\d{10}$/.test(Company_Mobile_number)) {
            message.error('Please enter a valid 10-digit mobile number for the company.');
            console.log('Please enter a valid 10-digit mobile number for the company.');
            return;
        }
        if (!/^\S+@\S+\.\S+$/.test(Company_email)) {
            message.error('Please enter a valid email address for the company.');
            console.log('Please enter a valid email address for the company.');
            return;
        }
        if (directors.some(director => !/^\d{10}$/.test(director.Director_mobile_number))) {
            message.error('Please enter valid 10-digit mobile numbers for all directors.');
            console.log('Please enter valid 10-digit mobile numbers for all directors.');
            return;
        }
        if (directors.some(director => !/^\S+@\S+\.\S+$/.test(director.Director_email))) {
            message.error('Please enter valid email addresses for all directors.');
            console.log('Please enter valid email addresses for all directors.');
            return;
        }
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/submit-company-profile', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Company_name, Company_CIN_number, Company_PAN_number, Company_GST_number, Company_MSME_number, Company_address, Company_Mobile_number, Company_email,
                    Directors: directors,
                    Services_opted: Object.keys(services).filter(service => services[service]),
                    Completed_step: 1 // step 1 is company profile submission
                })
            });
            const data = await response.json();
            if (response.status === 201) {
               //console.log(data.message);
                getUserData(); // Refresh user data to update Completed_step
                setSubmitloading(false);
                setCompanydetails({
                    Company_name: '',
                    Company_CIN_number: '',
                    Company_PAN_number: '',
                    Company_GST_number: '',
                    Company_MSME_number: '',
                    Company_address: '',
                    Company_Mobile_number: '',
                    Company_email: '',
                })
                setDirectors({
                    Director_name: "",
                    Director_mobile_number: "",
                    Director_email: "",
                    Director_DIN_number: "",
                    Date_of_appointment: "",
                    Share_perecentage: "",
                    Is_Authroized_signatory: false,
                })
                setServices({
                    Payout: false,
                    BBPS: false,
                    Mobile_Recharge: false,
                    Payin_UPI: false,
                    Aeps: false,
                    DMT: false,
                    Payment_Gateway_PG: false,
                    Bank_Verification: false,
                })
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setSubmitloading(false);
    }

    const handleRectificationSubmit = async () => {
        const { Company_name, Company_CIN_number, Company_PAN_number, Company_GST_number, Company_MSME_number, Company_address, Company_Mobile_number, Company_email } = companydetails;
        if (!Company_name || !Company_CIN_number || !Company_PAN_number || !Company_GST_number || !Company_address || !Company_Mobile_number || !Company_email) {
            message.error('Please fill all required company details.');
            console.log('Please fill all required company details.');
            return;
        }
        if (directors.some(director => !director.Director_name || !director.Director_mobile_number || !director.Director_email || !director.Director_DIN_number || !director.Date_of_appointment || !director.Share_perecentage)) {
            message.error('Please fill all required director details.');
            console.log('Please fill all required director details.');
            return;
        }
        if (Object.keys(services).every(service => !services[service])) {
            message.error('Please select at least one service.');
            console.log('Please select at least one service.');
            return;
        }
        if (directors.filter(director => director.Is_Authroized_signatory).length === 0) {
            message.error('Please select at least one authorized signatory.');
            console.log('Please select at least one authorized signatory.');
            return;
        }
        if (directors.filter(director => director.Is_Authroized_signatory).length > 1) {
            message.error('Only one director can be the authorized signatory. Please correct the selection.');
            console.log('Only one director can be the authorized signatory. Please correct the selection.');
            return;
        }
        if (directors.reduce((total, director) => total + Number(director.Share_perecentage), 0) !== 100) {
            message.error('Total share percentage must equal 100%. Please adjust the share percentages.');
            console.log('Total share percentage must equal 100%. Please adjust the share percentages.');
            return;
        }
        if (!/^\d{10}$/.test(Company_Mobile_number)) {
            message.error('Please enter a valid 10-digit mobile number for the company.');
            console.log('Please enter a valid 10-digit mobile number for the company.');
            return;
        }
        if (!/^\S+@\S+\.\S+$/.test(Company_email)) {
            message.error('Please enter a valid email address for the company.');
            console.log('Please enter a valid email address for the company.');
            return;
        }
        if (directors.some(director => !/^\d{10}$/.test(director.Director_mobile_number))) {
            message.error('Please enter valid 10-digit mobile numbers for all directors.');
            console.log('Please enter valid 10-digit mobile numbers for all directors.');
            return;
        }
        if (directors.some(director => !/^\S+@\S+\.\S+$/.test(director.Director_email))) {
            message.error('Please enter valid email addresses for all directors.');
            console.log('Please enter valid email addresses for all directors.');
            return;
        }
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/company-profile', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Company_name, Company_CIN_number, Company_PAN_number, Company_GST_number, Company_MSME_number, Company_address, Company_Mobile_number, Company_email,
                    Directors: directors,
                    Services_opted: Object.keys(services).filter(service => services[service]),
                    Company_profile_schema_id: submissionDetails?.Company_profile_schema_id
                })
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setSubmitloading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setSubmitloading(false);
    }

    useEffect(() => {
        const getUserData = async () => {
            setSubmitloading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            // console.log(data);
            if (response.status === 200) {
                const profile = data.RectificationDetails.Company_profile_schema_id;
                // Company Details
                setCompanydetails({
                    Company_name: profile.Company_name || "",
                    Company_CIN_number: profile.Company_CIN_number || "",
                    Company_PAN_number: profile.Company_PAN_number || "",
                    Company_GST_number: profile.Company_GST_number || "",
                    Company_MSME_number: profile.Company_MSME_number || "",
                    Company_address: profile.Company_address || "",
                    Company_Mobile_number: profile.Company_Mobile_number || "",
                    Company_email: profile.Company_email || "",
                });

                // Directors
                setDirectors(profile.Directors || []);

                // Services
                setServices({
                    Payout: profile.Services_opted?.includes("Payout"),
                    BBPS: profile.Services_opted?.includes("BBPS"),
                    Mobile_Recharge: profile.Services_opted?.includes("Mobile_Recharge"),
                    Payin_UPI: profile.Services_opted?.includes("Payin_UPI"),
                    Aeps: profile.Services_opted?.includes("Aeps"),
                    DMT: profile.Services_opted?.includes("DMT"),
                    Payment_Gateway_PG: profile.Services_opted?.includes("Payment_Gateway_PG"),
                    Bank_Verification: profile.Services_opted?.includes("Bank_Verification"),
                });

                setSubmitloading(false);
            } else if (response.status === 401) {
                setSubmitloading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setSubmitloading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setSubmitloading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    // console.log(submissionDetails);

    return (
        <>

            <Flex gap="medium" vertical>
                <Spin spinning={submitloading} size="large" description="Please wait...">
                    <Card title="Fill your comapny and service details" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        <Group>
                            <TextInput size="md" label="Company name" placeholder="Company name" required radius={'xs'} name="Company_name" value={companydetails.Company_name} onChange={(e) => handelChangeCompanyDetails('Company_name', e.target.value)} />
                            <TextInput size="md" label="Company CIN number" placeholder="Company cin number" required radius={'xs'} name="Company_CIN_number" value={companydetails.Company_CIN_number} onChange={(e) => handelChangeCompanyDetails('Company_CIN_number', e.target.value)} />
                            <TextInput size="md" label="Company PAN number" placeholder="Company PAN number " required radius={'xs'} name="Company_PAN_number" value={companydetails.Company_PAN_number} onChange={(e) => handelChangeCompanyDetails('Company_PAN_number', e.target.value)} />
                            <TextInput size="md" label="GST number " placeholder="GST number" required radius={'xs'} name="Company_GST_number" value={companydetails.Company_GST_number} onChange={(e) => handelChangeCompanyDetails('Company_GST_number', e.target.value)} />
                            <TextInput size="md" label="MSME number (Optional)" placeholder="MSME number" radius={'xs'} name="Company_MSME_number" value={companydetails.Company_MSME_number} onChange={(e) => handelChangeCompanyDetails('Company_MSME_number', e.target.value)} />
                            <TextInput size="md" label="Company address" placeholder="Company address" required radius={'xs'} name="Company_address" value={companydetails.Company_address} onChange={(e) => handelChangeCompanyDetails('Company_address', e.target.value)} />
                            <TextInput size="md" label="Company mobile number" placeholder="Company mobile number" required radius={'xs'} name="Company_Mobile_number" value={companydetails.Company_Mobile_number} onChange={(e) => handelChangeCompanyDetails('Company_Mobile_number', e.target.value)} />
                            <TextInput size="md" label="Company email id" placeholder="Company email id" required radius={'xs'} name="Company_email" value={companydetails.Company_email} onChange={(e) => handelChangeCompanyDetails('Company_email', e.target.value)} />
                        </Group>
                        <Divider label="Fill Director details" my="sm" variant="dashed" labelPosition="center" />
                        {directors?.map((director, index) => (
                            <Group key={index} mt={'lg'}>
                                <TextInput
                                    label={"Director name " + (index + 1)}
                                    value={director.Director_name}
                                    onChange={(e) => handleChange(index, "Director_name", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Director mobile number"
                                    value={director.Director_mobile_number}
                                    onChange={(e) => handleChange(index, "Director_mobile_number", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Director email id"
                                    value={director.Director_email}
                                    onChange={(e) => handleChange(index, "Director_email", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Director DIN number"
                                    value={director.Director_DIN_number}
                                    onChange={(e) => handleChange(index, "Director_DIN_number", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Date of appointment"
                                    value={director.Date_of_appointment}
                                    onChange={(e) =>
                                        handleChange(index, "Date_of_appointment", e.target.value)
                                    }
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Share %"
                                    value={director.Share_perecentage}
                                    onChange={(e) => handleChange(index, "Share_perecentage", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                {/* Authorized Signatory */}
                                <Checkbox
                                    label="is Authorized Signatory?"
                                    checked={director.Is_Authroized_signatory}
                                    onChange={() => handleAuthorizedChange(index)}
                                />
                                <Button mt="xs" onClick={addDirector} size="xs" variant="light">
                                    + Add Director
                                </Button>
                                {directors.length > 1 && (
                                    <Button
                                        mt="xs"
                                        color="red"
                                        variant="light"
                                        onClick={() => removeDirector(index)}
                                        size="xs"
                                    >
                                        - Remove Director
                                    </Button>
                                )}
                            </Group>
                        ))}
                        <Divider label="Select services" my="sm" variant="dashed" labelPosition="center" />
                        <Group mt={'lg'}>
                            <Checkbox label="Payout" checked={services.Payout} onChange={() => handleServiceChange('Payout')} />
                            {/* <Checkbox label="BBPS" checked={services.BBPS} onChange={() => handleServiceChange('BBPS')} disabled /> */}
                            {/* <Checkbox label="Mobile Recharge" checked={services.Mobile_Recharge} onChange={() => handleServiceChange('Mobile_Recharge')} disabled /> */}
                            {/* <Checkbox label="Payin (UPI)" checked={services.Payin_UPI} onChange={() => handleServiceChange('Payin_UPI')} /> */}
                            {/* <Checkbox label="Aeps" checked={services.Aeps} onChange={() => handleServiceChange('Aeps')} disabled /> */}
                            {/* <Checkbox label="DMT" checked={services.DMT} onChange={() => handleServiceChange('DMT')} disabled /> */}
                            {/* <Checkbox label="Payment Gateway (PG)" checked={services.Payment_Gateway_PG} onChange={() => handleServiceChange('Payment_Gateway_PG')} disabled /> */}
                            <Checkbox label="Bank Verification" checked={services.Bank_Verification} onChange={() => handleServiceChange('Bank_Verification')} />
                        </Group>

                        <Group justify="end">
                            {/* <Button mt={'md'} size="lg" color="lime" variant="light" onClick={handleSubmit} loading={submitloading}>Save changes</Button> */}
                            <Button
                                mt={'md'} size="lg" color="lime" variant="light"
                                loading={submitloading}
                                onClick={
                                    rectification
                                        ? handleRectificationSubmit
                                        : handleSubmit
                                }
                            >
                                {
                                    rectification
                                        ? "Submit Rectification"
                                        : "Save Changes"
                                }
                            </Button>
                        </Group>

                    </Card>
                </Spin>
            </Flex>


        </>
    )
}
export default Companyprofiles